/**
 * DevicePage.jsx
 * Pagina de Cadastro/Edicao de Dispositivo com Wizard Premium
 *
 * Rotas (padrao Traccar):
 *   /settings/device      -> Criar novo
 *   /settings/device/:id  -> Editar existente
 *
 * Nota: Arquivo original salvo em DevicePage.original.jsx
 */

import React, { useState, useEffect } from 'react';
import {
 Box, Typography, CircularProgress, Button 
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { usePremiumTokens } from '../common/theme/usePremiumTokens';
import { useTranslation } from '../common/components/LocalizationProvider';
import DeviceFormWizard from './components/DeviceFormWizard';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';

const DevicePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const t = useTranslation();
  const tokens = usePremiumTokens();

  const [device, setDevice] = useState(null);
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState(null);

  const colors = {
    accent: tokens?.accent?.primary || '#00d4aa',
    error: tokens?.semantic?.error || '#f85149',
    textSecondary: tokens?.text?.secondary || '#8b949e',
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      fetch(`/api/devices/${id}`)
        .then((res) => {
          if (!res.ok) throw new Error(t('wizardErrorNotFound') || 'Dispositivo nao encontrado');
          return res.json();
        })
        .then((data) => {
          setDevice(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [id, t]);

  if (loading) {
    return (
      <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedDevice']}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress sx={{ color: colors.accent }} />
        </Box>
      </PageLayout>
    );
  }

  if (error) {
    return (
      <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedDevice']}>
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography sx={{ color: colors.error, mb: 2 }}>{error}</Typography>
          <Button
            variant="outlined"
            onClick={() => navigate('/settings/devices')}
            sx={{ color: colors.textSecondary, borderColor: colors.textSecondary }}
          >
            {t('sharedBack') || 'Voltar'}
          </Button>
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedDevice']}>
      <Box sx={{ p: { xs: 1, sm: 2 } }}>
        <DeviceFormWizard
          device={device}
          onSave={() => navigate('/settings/devices')}
          onCancel={() => navigate('/settings/devices')}
        />
      </Box>
    </PageLayout>
  );
};

export default DevicePage;
